import { action } from 'typesafe-actions';
import localStorage from 'local-storage';
import { IPagination } from 'app/types/common';
import { FixtureMatchesActionTypes as types } from './types';

/* ********************************* APP ACTIONS ********************************* */

export const createFixtureMatch = (data): any => action(types.CREATE_FIXTURE_MATCH_REQUESTED, data);

export const updateFixtureMatch = (data): any => action(types.UPDATE_FIXTURE_MATCH_REQUESTED, data);

export const deleteFixtureMatch = (fixtureMatchId): any => action(types.UPDATE_FIXTURE_MATCH_REQUESTED, fixtureMatchId);

export const getFixtureMatch = (
  fixtureMatchId,
  eventDashboardId = undefined,
): any => action(types.GET_FIXTURE_MATCH_REQUESTED, { id: fixtureMatchId, eventDashboardId });

export const getAllFixtureMatches = (
  pagination: IPagination = undefined,
  compile = true,
  eventDashboardId = undefined,
): any => action(types.GET_ALL_FIXTURE_MATCHS_REQUESTED, {
  pagination,
  compile,
  eventDashboardId,
});

export const selectFixtureMatch = (fixtureMatchId): any => action(types.SELECT_FIXTURE_MATCH_REQUESTED, {
  currentFixtureMatchId: fixtureMatchId,
});

/* ********************************* SAGA ACTIONS ********************************* */
export const sagaActions = {
  createFixtureMatchPending: (payload): any => action(types.CREATE_FIXTURE_MATCH_PENDING, payload),
  createFixtureMatchesuccess: (response): any => action(types.CREATE_FIXTURE_MATCH_SUCCESS, {
    fixtureMatchesById: response.entities.fixtureMatches,
    currentFixtureMatchId: response.result,
  }),
  updateFixtureMatchPending: (payload): any => action(types.UPDATE_FIXTURE_MATCH_PENDING, payload),
  updateFixtureMatchesuccess: (response): any => action(types.UPDATE_FIXTURE_MATCH_SUCCESS, {
    fixtureMatchesById: response.entities.fixtureMatches,
    currentFixtureMatchId: response.result,
  }),
  updateFixtureMatchFailed: (error): any => action(types.UPDATE_FIXTURE_MATCH_FAIL, { backendErrors: error }),
  deleteFixtureMatchPending: (): any => action(types.UPDATE_FIXTURE_MATCH_PENDING, {}),
  deleteFixtureMatchesuccess: (response, userId): any => {
    localStorage.set(userId, { currentFixtureMatchId: null });

    return action(types.DELETE_FIXTURE_MATCH_SUCCESS, {
      currentFixtureMatchId: response,
    });
  },
  getFixtureMatchPending: (): any => action(types.GET_FIXTURE_MATCH_PENDING, {}),
  getFixtureMatchesuccess: (response): any => action(types.GET_FIXTURE_MATCH_SUCCESS, {
    fixtureMatchesById: response.entities.fixtureMatches,
    currentFixtureMatchId: response.result,
  }),
  getFixtureMatchFailed: (error): any => action(types.GET_FIXTURE_MATCH_FAIL, { backendErrors: error }),
  deleteFixtureMatchFailed: (error): any => action(types.UPDATE_FIXTURE_MATCH_FAIL, { backendErrors: error }),
  getAllFixtureMatchesPending: (pagination): any => action(types.GET_ALL_FIXTURE_MATCHS_PENDING, { pagination }),
  getAllFixtureMatchesSuccess: (response, meta): any => action(types.GET_ALL_FIXTURE_MATCHS_SUCCESS, {
    fixtureMatchesById: response.entities.fixtureMatches,
    fixtureMatchIds: response.result,
    meta,
  }),
  getAllFixtureMatchesFailed: (error): any => action(types.GET_ALL_FIXTURE_MATCHS_FAIL, { backendErrors: error }),
  createFixtureMatchFailed: (error): any => action(types.CREATE_FIXTURE_MATCH_FAIL, { backendErrors: error }),
};

export default null;
